import { render, staticRenderFns } from "./stumonth.vue?vue&type=template&id=28591ce9&scoped=true"
import script from "./stumonth.vue?vue&type=script&lang=js"
export * from "./stumonth.vue?vue&type=script&lang=js"
import style0 from "./stumonth.vue?vue&type=style&index=0&id=28591ce9&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28591ce9",
  null
  
)

export default component.exports